const CHECK_HEALTH = 'CHECK_HEALTH'
const CHECK_HEALTH_SUCCESS = 'CHECK_HEALTH_SUCCESS'
const CHECK_HEALTH_ERROR = 'CHECK_HEALTH_ERROR'

const GET_CHATS = 'GET_CHATS'
const GET_CHATS_SUCCESS = 'GET_CHATS_SUCCESS'
const GET_CHATS_ERROR = 'GET_CHATS_ERROR'

const SEND_CHAT_MESSAGE = 'SEND_CHAT_MESSAGE'
const SEND_CHAT_MESSAGE_SUCCESS = 'SEND_CHAT_MESSAGE_SUCCESS'
const SEND_CHAT_MESSAGE_ERROR = 'SEND_CHAT_MESSAGE_ERROR'

const GET_CHAT_MESSAGES = 'GET_CHAT_MESSAGES'
const GET_CHAT_MESSAGES_SUCCESS = 'GET_CHAT_MESSAGES_SUCCESS'
const GET_CHAT_MESSAGES_ERROR = 'GET_CHAT_MESSAGES_ERROR'

const UPLOAD_CHAT_ATTACHMENT = 'UPLOAD_CHAT_ATTACHMENT'
const UPLOAD_CHAT_ATTACHMENT_SUCCESS = 'UPLOAD_CHAT_ATTACHMENT_SUCCESS'
const UPLOAD_CHAT_ATTACHMENT_ERROR = 'UPLOAD_CHAT_ATTACHMENT_ERROR'

const DELETE_CHAT_ATTACHMENT = 'DELETE_CHAT_ATTACHMENT'
const DELETE_CHAT_ATTACHMENT_SUCCESS = 'DELETE_CHAT_ATTACHMENT_SUCCESS'
const DELETE_CHAT_ATTACHMENT_ERROR = 'DELETE_CHAT_ATTACHMENT_ERROR'

const UPDATE_CHAT_MESSAGE = 'UPDATE_CHAT_MESSAGE'
const UPDATE_CHAT_MESSAGE_SUCCESS = 'UPDATE_CHAT_MESSAGE_SUCCESS'
const UPDATE_CHAT_MESSAGE_ERROR = 'UPDATE_CHAT_MESSAGE_ERROR'

const CHECK_ATTACHMENT_STATUS = 'CHECK_ATTACHMENT_STATUS'
const CHECK_ATTACHMENT_STATUS_SUCCESS = 'CHECK_ATTACHMENT_STATUS_SUCCESS'
const CHECK_ATTACHMENT_STATUS_ERROR = 'CHECK_ATTACHMENT_STATUS_ERROR'

const CHAT_DRAWER_OPEN_SUCCESS = 'CHAT_DRAWER_OPEN_SUCCESS'
const ERROR_OCCURRED = 'ERROR_OCCURRED'

const SET_CHAT_ID = 'SET_CHAT_ID'

const FINAL_TOOL = 'FINAL_TOOL'
const FINAL_TOOL_SUCCESS = 'FINAL_TOOL_SUCCESS'
const FINAL_TOOL_ERROR = 'FINAL_TOOL_ERROR'

const LLM_SET_CHAT_CONTENT = 'LLM_SET_CHAT_CONTENT'

const GET_TRANSLATED_CONTENT = 'GET_TRANSLATED_CONTENT'
const GET_TRANSLATED_CONTENT_SUCCESS = 'GET_TRANSLATED_CONTENT_SUCCESS'
const GET_TRANSLATED_CONTENT_ERROR = 'GET_TRANSLATED_CONTENT_ERROR'

export {
  CHECK_HEALTH,
  CHECK_HEALTH_SUCCESS,
  CHECK_HEALTH_ERROR,
  GET_CHATS,
  GET_CHATS_SUCCESS,
  GET_CHATS_ERROR,
  SEND_CHAT_MESSAGE,
  SEND_CHAT_MESSAGE_SUCCESS,
  SEND_CHAT_MESSAGE_ERROR,
  GET_CHAT_MESSAGES,
  GET_CHAT_MESSAGES_SUCCESS,
  GET_CHAT_MESSAGES_ERROR,
  UPLOAD_CHAT_ATTACHMENT,
  UPLOAD_CHAT_ATTACHMENT_SUCCESS,
  UPLOAD_CHAT_ATTACHMENT_ERROR,
  DELETE_CHAT_ATTACHMENT,
  DELETE_CHAT_ATTACHMENT_SUCCESS,
  DELETE_CHAT_ATTACHMENT_ERROR,
  UPDATE_CHAT_MESSAGE,
  UPDATE_CHAT_MESSAGE_SUCCESS,
  UPDATE_CHAT_MESSAGE_ERROR,
  CHECK_ATTACHMENT_STATUS,
  CHECK_ATTACHMENT_STATUS_SUCCESS,
  CHECK_ATTACHMENT_STATUS_ERROR,
  CHAT_DRAWER_OPEN_SUCCESS,
  ERROR_OCCURRED,
  SET_CHAT_ID,
  FINAL_TOOL,
  FINAL_TOOL_SUCCESS,
  FINAL_TOOL_ERROR,
  LLM_SET_CHAT_CONTENT,
  GET_TRANSLATED_CONTENT,
  GET_TRANSLATED_CONTENT_SUCCESS,
  GET_TRANSLATED_CONTENT_ERROR,
}
